import ManagersContext from '../../containers/ManagersContext'
import {ReactNode, useContext} from 'react'
interface iPublinkProps {
  pubkey: string,
  children: ReactNode
}

function Publink (props: iPublinkProps) {
  const {docsManager} = useContext(ManagersContext)
  return (
    <a href={docsManager.get(props.pubkey)}
      target='_BLANK'
      rel="noreferrer">{props.children}</a>
  )
}
export default function InnerPagePublications () {
  return (
    <div>
      <header>
        <h1>Publications</h1>
        <p>Prior to becoming a professional software developer, I was a graduate student and then
          academic researcher in
          various disciplines relating to music and human hearing: auditory grouping,
          Digital Signal Processing for music synthesis, acoustics of musical instruments, and orchestration.
        </p>
        <p>Want to see my <a href='http://classic-web.archive.org/web/19990909140857re_/sparky.parmly.luc.edu/sandell' target='_BLANK' rel="noreferrer">1995 Home Page</a> from those days?  (Courtesy of the <a href='http://wayback.archive.org/web/' target='_BLANK' rel="noreferrer">Internet Archive Wayback Machine</a>)
        </p>
      </header>
      <dl>
        <dt>Links to Peer Review Articles</dt>
        <dd><b>Music Perception</b>:
          <Publink pubkey='1995-01-01_roles_MP'>1995</Publink>,&nbsp;
          <Publink pubkey='1987-01-01_perception_MP'>1987</Publink><br />
          <b>Journal of the Audio Engineering Society</b>:
          <Publink pubkey='1995-12-01_perceptual_JAES'>1995</Publink><br />
          <b>Journal of the Acoustical Society America</b>:
          <Publink pubkey='1995-05-01_absence_JASA'>1995</Publink>,&nbsp;
          <Publink pubkey='1994-05-01_effect_JASA'>1994</Publink>
        </dd>
        <dt>Dissertation</dt>
        <dd>
          PhD Dissertation, Northwestern University, 1991.
          Title:
          <i>Concurrent Timbres in Orchestration: a Perceptual Study of Factors Determining 'blend'</i><br />
          <ul>
            <li><a href='http://adsabs.harvard.edu/abs/1991PhDT.......313S' target='_BLANK' rel="noreferrer">Online abstract</a></li>
            <li><a href='/dissertation'>Downloads</a></li>
          </ul>
        </dd>
        <dt>Master's Thesis</dt>
        <dd>
          Eastman School of Music, 1983.
          Title:
          <i>Edgard Varese's <u>Ecuatorial</u>; A Pitch-Class Set Analysis</i><br />
          <ul>
            <li><a href='/thesis'>Downloads</a></li>
          </ul>
        </dd>
        <dt>Links to Articles in Conference Proceedings</dt>
        <dd>
          <b>Edgard Varese Symposium, Columbia University</b>:
          <Publink pubkey='1984-04-06_ColumbiaVareseSymposium'>1984</Publink>
          {/*<a href="https://s3.us-west-1.amazonaws.com/gregsandell.com/resources/1984-04-06_ColumbiaVareseSymposium.pdf"*/}
          {/*  target='_BLANK'*/}
          {/*  rel="noreferrer">1984</a>*/}
          <br/>
          <b>Acoustical Society of America</b>:&nbsp;
          <Publink pubkey='1989-11-29_effect_ASA'>1989</Publink>,&nbsp;
          <Publink pubkey='1998-06-20_macrotimbre_ASA'>1998</Publink>,&nbsp;
          <Publink pubkey='1996-12-04_recognition_ASA'>1996a</Publink>,&nbsp;
          <Publink pubkey='1996-12-05_identifying_ASA'>1996b</Publink>,&nbsp;
          <Publink pubkey='1994-06-09_effect_ASA'>1994a</Publink>,&nbsp;
          <Publink pubkey='1994-06-09_analysis_ASA'>1994b</Publink>,&nbsp;
          <br/>
          <b>International Computer Music Conference</b>:&nbsp;
          <Publink pubkey='1989-01-01_perception_ICMC'>1989</Publink>,&nbsp;
          <Publink pubkey='1992-10-14_prototyping_ICMC'>1992</Publink>,&nbsp;
          <Publink pubkey='1991-10-01_library_ICMC'>1991</Publink>,&nbsp;
          <br/>
          <b>Society for Music Perception &amp; Cognition</b>:&nbsp;
          {/* Leaving out spaces between the links below to fit everything on one line */}
          <Publink pubkey='1997-06-07_perceptual_ESCOM'>1997a</Publink>,
          <Publink pubkey='1997-07-31_perceptual_SMPC'>1997b</Publink>,
          <Publink pubkey='1996-08-11_sharc_ICMPC'>1996</Publink>,
          <Publink pubkey='1995-06-22_grouping_SMPC'>1995a</Publink>,
          <Publink pubkey='1995-06-22_perceptual_SMPC'>1995b</Publink>,
          <Publink pubkey='1992-02-22_factors_ICMPC'>1992</Publink>
          <br/>
          <b>Society for Music Theory</b>:&nbsp;
          <Publink pubkey='1989-10-26_timbre_SMT'>1989</Publink>
        </dd>
        <dt>Links to Book Reviews</dt>
        <dd><b>Music Perception</b>:
          <Publink pubkey='1996-06-01_auditory_MP'>1996</Publink><br />
          <b>Music Theory Spectrum</b>:
          <Publink pubkey='1990-09-01_soundColor_MTS'>1990</Publink>
        </dd>
      </dl>
    </div>
  )
}
